 const apiurl = "https://aammiimalaysia.com/admin/api/";

 export {apiurl}